import Vue from 'vue'
import _ from 'lodash'
// import moment from 'moment'

const appUtils = {}

appUtils.install = function (Vue) {
    Vue.prototype.$utils = {
        sleep(ms) {
            return new Promise(res => setTimeout(res, ms))
        },
        set(to, ...from) {
//console.log('from', from)
            for (let i = 0; i < from.length; i++) {
                if (from[i] === null || (typeof from[i] !== 'object' && !Array.isArray(from[i]))) {
//console.log('continue', i, from[i])
                    continue
                }

                // fromを壊さないようにデータだけ取得
                from[i] = JSON.parse(JSON.stringify(from[i]))

                Object.keys(from[i]).forEach((key) => {
                    if (Array.isArray(from[i][key])) {
                        if (Array.isArray(to[key])) {
                            to[key].splice(0)
                        } else {
                            Vue.set(to, key, [])
                        }
                        from[i][key].forEach((val) => {
//console.log('to', to)
//console.log('key', key)
//console.log('push val', val)
                            to[key].push(val)
                        })
                    } else if (typeof from[i][key] === 'object' && from[i][key] !== null) {
                        Vue.set(to, key, {})
                        Object.keys(from[i][key]).forEach((key2) => {
//console.log('to', to)
//console.log('key', key)
//console.log('to[key]', to[key])
//console.log('key2', key2)
//console.log('from[i][key][key2]', from[i][key][key2])
                            Vue.set(to[key], key2, from[i][key][key2])
                        })
                    } else {
//console.log('to', to)
//console.log('key', key)
//console.log('from[i][key]', from[i][key])
                        Vue.set(to, key, from[i][key])
                    }
                })
            }
//console.log('result to', to)
        },
        touch(objOrArray) {
            if (!objOrArray) {
            } else if (typeof objOrArray === 'string') {
                objOrArray = {}
            } else if (Array.isArray(objOrArray)) {
                objOrArray.push([])
                objOrArray.pop()
            } else {
                Vue.set(objOrArray, 'touched_at', new Date().toISOString())
            }
        },
        empty(objOrArray) {
            if (typeof objOrArray === 'string') {
                objOrArray = {}
            } else if (Array.isArray(objOrArray)) {
                objOrArray.splice(0, objOrArray.length)
            } else {
                Object.keys(objOrArray).forEach((key) => {
                    Vue.delete(objOrArray, key)
                })
            }
        },
        addPrefixProperty(obj, prefix) {
            let newObj = Object.keys(obj).reduce((a, c) => (a[`${prefix}${c}`] = obj[c], a), {})
            return newObj
        },
        extend(a, b) {
            return Vue.util.extend(a, b)
        },
        copy(a) {
            return _.cloneDeep(a)
        },
        swap(arr, index1, index2) {
            const work = arr[index1]
            arr.splice(index1, 1, arr[index2])
            arr.splice(index2, 1, work)
//            [ arr[index1], arr[index2], ] = [ arr[index2], arr[index1], ]
        },
        keyBy(arr, key) {
            return arr.reduce(
                (map, v) => Object.assign(map, { [v[key]]: v }),
                {}
            )
        },
        serializeformData(data, bracketsForArray) {
            let obj = {};
            for (let [key, value] of data) {
                if (obj[key] !== undefined) {
                    if (!Array.isArray(obj[key])) {
                        obj[key] = [obj[key]];
                    }
                    obj[key].push(value);
                } else {
                    obj[key] = value;
                }
            }
            if (bracketsForArray) {
                for (let key in obj) {
                    if (key.endsWith('[]')) {
                        obj[key.slice(0, -2)] = obj[key]
                        delete obj[key]
                    }
                }
            }
            return obj;
        },
        get(obj, path, defaultValue = null) {
            let result = obj
            let pathes = path.split('.')
            for (let i = 0; i < pathes.length; i++) {
                result = result[pathes[i]]
                if (typeof result === 'undefined') {
                    return defaultValue
                }
            }
            return result
        },
        async modalAlert(app, title, body, options) {
            const options_default = {
                okOnly: true,
                okTitle: 'OK',
                okVariant: 'outline-secondary',
                cancelVariant: 'none',
            }
            app.$utils.set(options_default, options)
            return Vue.prototype.$utils.modalConfirm(app, title, body, options_default)
        },
        async modalConfirm(app, title, body, options) {
            const h = app.$createElement

            let messageVNode = null
            if (typeof body === 'string') {
                messageVNode = h('div', { class: [''] }, [
                    h('p', { class: ['text-left'] }, [
                        body,
                    ]),
                ])
            } else {
                messageVNode = body
            }

            const options_default = {
                title: title,
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'はい',
                cancelTitle: 'いいえ',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }
            app.$utils.set(options_default, options)

            let result = await app.$bvModal.msgBoxConfirm([messageVNode], options_default)
            .then((value) => {
                return value
            })
            .catch((error) => {
                return error
            })

            return result
        },
        async modalConfirmKeyword(app, title, body, options, keyword) {
            const h = app.$createElement

console.log(123)
            let messageVNode = null
            if (typeof body === 'string') {
                messageVNode = h('div', { class: [''] }, [
                    h('p', { class: ['text-left'] }, [
                        body,
                    ]),
                ])
            } else {
                messageVNode = body
            }

            const options_default = {
                title: title,
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: 'はい',
                cancelTitle: 'いいえ',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }
            app.$utils.set(options_default, options)

            let result = await app.$bvModal.msgBoxConfirm([
                    messageVNode,
                    h('input', { class: ['form-control'], type: 'text' }),
            ], options_default)
            .then((value) => {
                if (!value) {
                    return false
                }
                const form = document.activeElement.closest('.modal-content').querySelector('.modal-body input')
                return form.value === keyword
            })
            .catch((error) => {
                return error
            })

            return result
        },
        // array, snake, pascal
        toNamingConvention(str, from, to) {
            let parts = [];
            if (Array.isArray(str)) {
                parts = str;
            } else {
                switch (from) {
                    case 'snake':
                        parts = str.split('_');
                        break;
                    case 'pascal':
                        parts = (str.match(/[A-Z][a-z0-9]*/g) ?? [])
                            .map(v => v.toLowerCase())
                            ;
                        break;
                    default:
                        break;
                }
            }
            switch (to) {
                case 'snake':
                    return parts.join('_').toLowerCase();
                case 'pascal':
                    return parts.map(v => v[0].toUpperCase() + v.slice(1)).join('');
                default:
                    return parts;
            }
        },
        // array, snake, pascal
        appendFormData(formData, data, parentKey = '') {
            if (data === null || data === undefined) {
                return;
            }

            if (data instanceof File) {
                formData.append(parentKey, data);
                return;
            }

            if (Array.isArray(data)) {
                if (data.length === 0) {
                    formData.append(parentKey, '');
                    return;
                }

                data.forEach((value, index) => {
                    appendFormData(formData, value, `${parentKey}[${index}]`);
                });

                return;
            }

            if (typeof data === 'object') {
                Object.keys(data).forEach(key => {
                    const newKey = parentKey ? `${parentKey}[${key}]` : key;
                    Vue.prototype.$utils.appendFormData(formData, data[key], newKey);
                });

                return;
            }

            // プリミティブ
            formData.append(parentKey, data);
        },
    }

    return Vue.prototype.$utils;
}

Vue.use(appUtils)

export default appUtils.install(Vue);
